<template>
<section class="container boxWithBorder" >
    <CarPreferredVendors @carPreferredVendors="carPreferredVendors"/>
    <AirPreferredVendors @airPreferredVendors="airPreferredVendors"/>
    <HotelPreferredVendors @hotelPreferredVendors="hotelPreferredVendors"/>
    <CarDailyCost @carDailyCost="carDailyCost" />
    <HotelDailyCost @hotelDailyCost ="hotelDailyCost"/>
    <HotelDailyCostWithExceptionCities @hotelDailyCostForExceptionCities ="hotelDailyCostForExceptionCities"   />
    <HotelDailyCostGsaRate @hotelDailyCostGsaDifference="hotelDailyCostGsaDifference"/>
    <CarSize @carSize="carSize" />
    <AirClassOfService  @classOfServices="classOfServices"/>
    <DomesticAirFareCap @domesticAirFareCap="domesticAirFareCap" />
    <InternationalAirFareCap @internationalAirFareCap="internationalAirFareCap" />
</section>  
</template>
<script>
import AirPreferredVendors from './AirPreferredVendors.vue';
import CarPreferredVendors from './CarPreferredVendors.vue';
import HotelPreferredVendors from './HotelPreferredVendors.vue';
import HotelDailyCost from './HotelDailyCost.vue';
import CarDailyCost from './CarDailyCost.vue';
import HotelDailyCostWithExceptionCities from './HotelDailyCostWithExceptionCities.vue';
import HotelDailyCostGsaRate from './HotelDailyCostGsaRate.vue';
import CarSize from './CarSize.vue';
import AirClassOfService from './AirClassOfService.vue';
import DomesticAirFareCap from './DomesticAirFareCap.vue';
import InternationalAirFareCap from './InternationalAirFareCap.vue';
    export default {
      name: "commonRules",
      components: {
        AirPreferredVendors,
        CarPreferredVendors,
        HotelPreferredVendors,
        HotelDailyCost,
        CarDailyCost,
        HotelDailyCostWithExceptionCities,
        HotelDailyCostGsaRate,
        CarSize,
        AirClassOfService,
        DomesticAirFareCap,
        InternationalAirFareCap
      },
      data() {
        return {
        }
      },
      methods:{
        /**
         * it can be change according to requirments or usage .
         */
        carPreferredVendors(val) {
          console.log(val,"car preferred vendors");
        },
        airPreferredVendors(val){
          console.log(val,"air preferred Vendors");
        },
        hotelPreferredVendors(val){
          console.log(val,'hotel preferred vendors')
        },
        /** In child component of carDailyCost and hotelDailyCost emitted the value on @input event . event can
         * be change as per requirement 
         */
         carDailyCost(val) {
          console.log(val,"car daily cost")
        },
        hotelDailyCost(val) {
         console.log(val,'hotel daily cost')
        },
        hotelDailyCostForExceptionCities(val){
          console.log(val,'hotel daily cost for exception cities')
        },
        hotelDailyCostGsaDifference(val){
          console.log(val,"hotelDailyCostGsaDifference");
        },
        domesticAirFareCap(val){
          console.log(val,"domesticAirFareCap");
        },
        internationalAirFareCap(val){
          console.log(val,'internationalAirFareCap')
        },
        carSize(val){
          console.log(val,'carSize')
        },
        classOfServices(val){
          console.log(val,'classOfServices')
        }
      },
    }
  </script>

  <style scoped>
  </style>